import { Box, Button, Checkbox, Radio, Stack, Typography } from "@mui/material";

interface Props {
  title: string;
  titleRight?: string;
  subtitle: string;
  checked: boolean;
  variant: "checkbox" | "radio";
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const ListItem = ({
  title,
  titleRight,
  subtitle,
  checked,
  variant,
  onChange,
  disabled,
}: Props) => {
  return (
    <Box
      component={Button}
      sx={{ textTransform: "none", padding: 0 }}
      onClick={() => onChange(!checked)}
      disabled={disabled}
    >
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          width: 1,
          paddingX: 2,
          paddingY: 1,
        }}
      >
        {variant === "checkbox" && (
          <Checkbox
            size="small"
            checked={checked}
            tabIndex={-1}
            disabled={disabled}
          />
        )}
        {variant === "radio" && (
          <Radio
            size="small"
            checked={checked}
            tabIndex={-1}
            disabled={disabled}
          />
        )}
        <Stack sx={{ alignItems: "start", flex: 1 }}>
          <Stack
            direction="row"
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
              width: 1,
            }}
          >
            <Typography variant="subtitle2">{title}</Typography>
            {titleRight && (
              <Typography
                variant="caption"
                color={disabled ? "inherit" : "text.secondary"}
              >
                {titleRight}
              </Typography>
            )}
          </Stack>
          <Typography variant="caption">{subtitle}</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ListItem;
